import { ResponseDto } from '@r1-frontend/api-domru/dadata/v1/address/check/dto/ResponseDto';

import { IAction } from '@r1-frontend/shared/types/Redux';

import { EActions } from '../constants/actions';
import { TFailedCheckResult } from '../reducer/initialState';

const checkingFinished = (checkingResult: ResponseDto | TFailedCheckResult): IAction<EActions.checkingFinish, { checkResult: ResponseDto | TFailedCheckResult }> => ({
    type: EActions.checkingFinish,
    payload: {
        checkResult: checkingResult,
    },
});

export default checkingFinished;
